module.exports = __webpack_public_path__ + "img/104.b81b50ff.png";